import { toast } from "react-toastify";
import api from "./api/api";

type GetListNFesParams = {
  pageNumber?: number;
  pageSize?: number;
  step?: "carregando" | "emitido" | "cancelado" | "";
  idDesk?: number | string
};

const NotasFiscaisService = {
  getConfig_NFe: async () => {
    try {
      const res = await api.get(`/empresas/nfe/config_nfe`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  saveConfig_NFe: async (payload: any) => {
    return api.post("/empresas/nfe/config_nfe", payload);
  },
  getNFes: async () => {
    try {
      const res = await api.get(`/empresas/nfe/listarNotas`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  cancelarNFSE(id_desk: string | number, justificativa: any) {
    return api.delete("/notaFiscalEletronica/cancelarNFSE", {
      params: { id_desk },
      data: {
        justificativa,
      },
    });
  },
  getListNFes: async ({
    pageNumber = 1,
    pageSize = 10,
    step = "",
    idDesk
  }: GetListNFesParams = {}) => {
    try {
      const res = await api.get(`/notaFiscalEletronica/listarNotas`, {
        params: { pageNumber, pageSize, step, idDesk },
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  getCnaes: async () => {
    try {
      const res = await api.get(`/notaFiscalEletronica/consultarCnpj/cnaes`);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  consultarItemServico: async (codigoCnae: string) => {
    try {
      const res = await api.get(`/notaFiscalEletronica/consultarItemServico`, {
        params: { codigoCnae },
      });
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
  gerarNFse: async (payload: any) => {
    try {
      const res = await api.post(
        "/notaFiscalEletronica/gerarNotaNFSE",
        payload
      );
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      toast.error(error.response.data.error);
      return error.response;
    }
  },
  consultarNota: async (payload: any) => {
    try {
      const res = await api.post(
        "/notaFiscalEletronica/consultarNota",
        payload
      );
      toast.success(res.data.msg);
      return res;
    } catch (error: any) {
      return error.response;
    }
  },
};

export default NotasFiscaisService;
